import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  royaltyPlanTemplate: null,
  royaltyPlanTemplates: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const royaltyPlanTemplateReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.ROYALTYPLANTEMPLATE_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.ROYALTYPLANTEMPLATE_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.ROYALTYPLANTEMPLATE_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default royaltyPlanTemplateReducer;
